var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTrafficSignal = function SvgIconTrafficSignal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.125 8.25a2.875 2.875 0 1 1 5.75 0 2.875 2.875 0 0 1-5.75 0M12 7.375a.875.875 0 1 0 0 1.75.875.875 0 0 0 0-1.75M12 12.875a2.875 2.875 0 1 0 0 5.75 2.875 2.875 0 0 0 0-5.75m-.875 2.875a.875.875 0 1 1 1.75 0 .875.875 0 0 1-1.75 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 15.25v5c0 .966.784 1.75 1.75 1.75h10.5A1.75 1.75 0 0 0 19 20.25v-5h1.25a1 1 0 1 0 0-2H19v-5.5h1.25a1 1 0 1 0 0-2H19v-2A1.75 1.75 0 0 0 17.25 2H6.75A1.75 1.75 0 0 0 5 3.75v2H3.75a1 1 0 0 0 0 2H5v5.5H3.75a1 1 0 1 0 0 2zM7 4v16h10V4z"
  }))));
};
export default SvgIconTrafficSignal;